import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import store from './redux/redux';
import App from './App';
import reportWebVitals from './reportWebVitals';
createRoot(document.getElementById('ReactApp')).render(
  <Provider store={store}>
    <App />
  </Provider>
);
reportWebVitals();





